import { injectable } from 'inversify'

export type RequestTrackId = symbol | string | number

export type RequestTrackInfo = {
  id: RequestTrackId
  methodKey: string
  abort?: () => void
}

@injectable()
export class RequestTracker {
  private requests: Map<RequestTrackId, RequestTrackInfo>
  private currentRequest: RequestTrackInfo | null = null

  constructor() {
    this.requests = new Map()
  }

  addRequest(request: RequestTrackInfo) {
    this.requests.set(request.id, request)
  }

  removeRequest(requestId: RequestTrackId) {
    this.requests.delete(requestId)
  }

  getRequest(requestId: RequestTrackId): RequestTrackInfo | undefined {
    return this.requests.get(requestId)
  }

  setCurrentRequest(request: RequestTrackInfo) {
    this.currentRequest = request
  }

  getCurrentRequest() {
    return this.currentRequest
  }

  getAllRequests(): RequestTrackInfo[] {
    return Array.from(this.requests.values())
  }
}
